/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';
import styles from './ShortcutsPage.less';

// We're lazy-loading the shortcuts content, because this component is used by
// the stand-alone route. The overlay version shares the "shortcuts" chunk, but
// loads it async-but-eagerly.
const Shortcuts = lazy(() =>
  import(/* webpackChunkName: "shortcuts" */ 'app/src/components/Shortcuts'),
);

export const ShortcutsPage = () => {
  return (
    <div className={styles.shortcutsPage}>
      <Suspense fallback={null}>
        <Shortcuts />
      </Suspense>
    </div>
  );
};
